module.exports = __webpack_public_path__ + "tenant-3-71859f0f78a8a7606f2b6354f14d5046.bundle.svg";